import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="control-group form-template-field" data-field-type="textarea">
  {{#if @attributes.label}}
    <label class="form-template-field__label">
      {{@attributes.label}}
      {{#if @validations.required}}
        {{d-icon "asterisk" class="form-template-field__required-indicator"}}
      {{/if}}
    </label>
  {{/if}}

  {{#if @attributes.description}}
    <span class="form-template-field__description">
      {{html-safe @attributes.description}}
    </span>
  {{/if}}

  <Textarea
    name={{@id}}
    @value={{@value}}
    class="form-template-field__textarea"
    placeholder={{@attributes.placeholder}}
    pattern={{@validations.pattern}}
    minlength={{@validations.minimum}}
    maxlength={{@validations.maximum}}
    required={{if @validations.required "required" ""}}
  />
</div>
*/
{
  "id": "mpc65LYI",
  "block": "[[[10,0],[14,0,\"control-group form-template-field\"],[14,\"data-field-type\",\"textarea\"],[12],[1,\"\\n\"],[41,[30,1,[\"label\"]],[[[1,\"    \"],[10,\"label\"],[14,0,\"form-template-field__label\"],[12],[1,\"\\n      \"],[1,[30,1,[\"label\"]]],[1,\"\\n\"],[41,[30,2,[\"required\"]],[[[1,\"        \"],[1,[28,[35,1],[\"asterisk\"],[[\"class\"],[\"form-template-field__required-indicator\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"description\"]],[[[1,\"    \"],[10,1],[14,0,\"form-template-field__description\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[[30,1,[\"description\"]]],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,3],[[16,3,[30,3]],[24,0,\"form-template-field__textarea\"],[16,\"placeholder\",[30,1,[\"placeholder\"]]],[16,\"pattern\",[30,2,[\"pattern\"]]],[16,\"minlength\",[30,2,[\"minimum\"]]],[16,\"maxlength\",[30,2,[\"maximum\"]]],[16,\"required\",[52,[30,2,[\"required\"]],\"required\",\"\"]]],[[\"@value\"],[[30,4]]],null],[1,\"\"],[13]],[\"@attributes\",\"@validations\",\"@id\",\"@value\"],false,[\"if\",\"d-icon\",\"html-safe\",\"textarea\"]]",
  "moduleName": "discourse/components/form-template-field/textarea.hbs",
  "isStrictMode": false
});